import httpClient from "../../api/httpClient";
import { createWrappedAsyncThunk } from "../createWrappedAsyncThunk";

export const getAppointments = createWrappedAsyncThunk(
  "appointments/getAppointments",
  async ({ month_year }) => {
    const { data } = await httpClient.get(`appointments`, {
      params: {
        month_year,
      },
    });
    return { month_year, data };
  },
);

export const saveAppointments = createWrappedAsyncThunk(
  "appointments/saveAppointments",
  async (payload) => {
    return await httpClient.post(`appointments`, payload);
  }
);
